import React, { Component } from 'react';
import {
  createStyles,
  Theme,
  WithStyles,
  Card,
  CardContent,
  withStyles,
  Typography,
  Grid,
} from '@material-ui/core';

import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { dashboardService } from '../services/dashboardService';


const styles = (theme: Theme) => createStyles({
  fontBold: {
    fontWeight: 400,
    fontSize: '2.8em',
  },
  fontline: {
    display: 'inline',
  },
  bdShadow: {
    MozBoxShadow: '0px 0px 10px rgba(0, 0, 0, 0.168337)',
    WebkitBoxShadow: '0px 0px 10px rgba(0, 0, 0, 0.168337)',
  },
  mb1x: {
    marginBottom: theme.spacing.unit * 2,
  },
  mr1x: {
    marginRight: theme.spacing.unit,
  },
  cardContentRoot: {
    position: 'relative',
    ...theme.mixins.gutters(),
    paddingBottom: theme.spacing.unit * 2,
    '& ul': {
      listStyle: 'none',
      display: 'flex',
      padding: 0,
      margin: 0,
    }
  },
  toggleDiv: {
    background: 'rgba(233, 239, 244, 0.48)',
    borderRadius: theme.shape.borderRadius,
  },
  toggle: {


    '& li': {
      ...theme.typography.body1,
      marginRight: theme.spacing.unit,
      borderRadius: theme.shape.borderRadius,

    },
    '& .active': {
      background: '#fff',
      paddingLeft: theme.spacing.unit,
      paddingRight: theme.spacing.unit,
    },
    '&:hover': {
      cursor: 'pointer',
    }
  },
  breadcrumb: {
    '& li': {
      ...theme.typography.body1,
      marginRight: theme.spacing.unit,
      borderRadius: theme.shape.borderRadius,

    },


  },

  dropdown: {
    float: "right",
    border: 'none',
    background: 'rgba(233, 239, 244, 0.48)',
    fontSize: 14,
    color: '#323C47',
    padding: theme.spacing.unit,
    borderRadius: theme.shape.borderRadius,
  },
  dropdown1: {
    height: 36,

  },
  dropdown2: {
    height: 36,

  },
});

interface DashboardStatsContentProps extends WithStyles<typeof styles> {
  noOfDays: number,
}

interface DashboardStatsContentState {
  questionCount: number,
  studyNotesCount: number,
  formulaCount: number,
  noOfDaysState: number,
  videosCount: number,
  testPaperCount: number,
}

class DashboardStatsContent extends Component<DashboardStatsContentProps, DashboardStatsContentState> {
  constructor(props: DashboardStatsContentProps) {
    super(props);
    this.state = {
      questionCount: 0,
      studyNotesCount: 0,
      formulaCount: 0,
      noOfDaysState: 0,
      videosCount: 0,
      testPaperCount: 0,
    }
  }

  componentDidMount() {
    this.getCount();
  }

  componentWillReceiveProps() {
    setTimeout(this.getCount.bind(this), 600);
  }


  getCount() {
    let { noOfDaysState } = this.state;
    let { noOfDays } = this.props;

    if (noOfDays != noOfDaysState) {
      dashboardService.getContentCount('studymaterial', noOfDays)
        .then((res: any) => {
          this.setState({ studyNotesCount: res });
        })

      dashboardService.getContentCount('question', noOfDays)
        .then((res: any) => {
          this.setState({ questionCount: res });
        })

      dashboardService.getContentCount('formulas', noOfDays)
        .then((res: any) => {
          this.setState({ formulaCount: res });
        })

      dashboardService.getContentCount('videos', noOfDays)
        .then((res: any) => {
          this.setState({ videosCount: res });
        })

      dashboardService.getContentCount('testpapers', noOfDays)
        .then((res: any) => {
          this.setState({ testPaperCount: res });
        })



      this.setState({ noOfDaysState: noOfDays });
    }
  }

  render() {
    const { classes } = this.props;
    const { questionCount, studyNotesCount, formulaCount, videosCount, testPaperCount } = this.state;


    return (
      <>
        <Grid container spacing={16}>
          <Grid item xs>
            <Card className={classes.bdShadow}>
              <CardContent className={classes.cardContentRoot}>
                <Typography variant="h2" className={classes.fontBold}>
                  {questionCount}
                </Typography>
                <Typography color="textSecondary">
                  Questions
          </Typography>
              </CardContent>
            </Card>
          </Grid>
          <Grid item xs>
            <Card className={classes.bdShadow}>
              <CardContent>
                <Typography variant="h2" className={classes.fontBold}>
                  {studyNotesCount}
                </Typography>
                <Typography>
                  Study Notes
          </Typography>
              </CardContent>
            </Card>
          </Grid>
          <Grid item xs>
            <Card className={classes.bdShadow}>
              <CardContent>
                <Typography variant="h2" className={classes.fontBold}>
                  {videosCount}
                </Typography>
                <Typography>
                  Videos
          </Typography>
              </CardContent>
            </Card>
          </Grid>
        </Grid>

        <Grid container spacing={16}>
          <Grid item xs={4}>
            <Card className={classes.bdShadow}>
              <CardContent>
                <Typography variant="h2" className={classes.fontBold}>
                  {testPaperCount}
                </Typography>
                <Typography>
                  Test Papers
        </Typography>
              </CardContent>
            </Card>
          </Grid>
          <Grid item xs={4}>
            <Card className={classes.bdShadow}>
              <CardContent>
                <Typography variant="h2" className={classes.fontBold}>
                  {formulaCount}
                </Typography>
                <Typography>
                  Formula Sheets
        </Typography>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      </>
    )
  }
}


const mapStateToProps = (state: any) => ({
});


const mapDispatchToProps = (dispatch: any) => bindActionCreators({

}, dispatch);



//@ts-ignore
export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(DashboardStatsContent));